import { gql, useQuery } from "@apollo/client"
import qs from "qs"
import { useEffect } from "react"
import { COACH_TOOLS_API } from "../../../../apolloClient"
import { BACKGROUND_CHECK_ORDER_FRAGMENT } from "../../../../utils/prospect/withProspectQuery"
import { resolveBackgroundCheckCta } from "../../../../utils/prospect/backgroundCheckCta"
import { StatusLink } from "./styles"
import { Button } from "@pga/pga-component-library"
import { useModal } from "../../../../components/Dashboard/JobSeekerDashboard/ModalContext"

export const LINK_TEST_ID = "background-check-departure-link"

export const BACKGROUND_CHECK_ORDER_QUERY = gql`
  query ProspectQuery {
    currentMember {
      prospect {
        backgroundCheckOrder {
          ${BACKGROUND_CHECK_ORDER_FRAGMENT}
        }
      }
    }
  }
`

export const BackgroundCheckDepartureLink = ({ order, presentation }) => {
  const { openModal } = useModal()
  const { backgroundCheckConfirmation } = qs.parse(window.location.search, {
    ignoreQueryPrefix: true,
  })

  useEffect(() => {
    if (backgroundCheckConfirmation) {
      openModal("backgroundCheck")
    }
  }, [backgroundCheckConfirmation, openModal])

  const cta = resolveBackgroundCheckCta(order)
  const monitorOrderStatus =
    !order?.awaitingModeration &&
    (cta.action === "hire_right" || !!order?.paidAt)

  useQuery(BACKGROUND_CHECK_ORDER_QUERY, {
    context: { api: COACH_TOOLS_API },
    skip: !monitorOrderStatus,
    pollInterval: 5000,
  })

  if (order?.awaitingModeration) {
    return null
  }

  if (cta.action === "hire_right") {
    if (presentation === "button") {
      return (
        <Button
          href={cta.url}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={LINK_TEST_ID}
        >
          {cta.label}
        </Button>
      )
    }

    return (
      <StatusLink
        href={cta.url}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={LINK_TEST_ID}
      >
        {cta.label}
      </StatusLink>
    )
  }

  const CallToAction = presentation === "button" ? Button : StatusLink

  return (
    <CallToAction
      onClick={() => openModal("backgroundCheck")}
      data-testid={LINK_TEST_ID}
    >
      {cta.label}
    </CallToAction>
  )
}

export default BackgroundCheckDepartureLink
